import React from 'react'

import { AccountCircle, School, Poll, BusinessCenter, CheckBox } from 'icons'

export default [
  {
    name: 'Profile',
    href: '#profile',
    icon: <AccountCircle />
  },
  {
    name: 'Education and experience',
    href: '#education-and-experience',
    icon: <School />
  },
  {
    name: 'Skills',
    href: '#skills',
    icon: <Poll />
  },
  {
    name: 'Projects',
    href: '#projects',
    icon: <BusinessCenter />
  },
  {
    name: 'Goals',
    href: '#interests-and-goals',
    icon: <CheckBox />
  }
]
